import React from 'react'
import './App.css'
import {Icon} from "./components/FormComps";

export default function Page500() {

  return (
    <main>
      <div className="jumbotron m-3">
        <center>
          <h1 style={{fontSize: "4.5rem", color: "var(--color-danger)"}}><Icon name="server_error"/></h1>
          <h1 style={{fontSize: "2.5rem", color: "var(--title-color)"}}>Internal Error</h1>
          <p className="lead" style={{color: "var(--label-color)"}}>
            <p>Something went wrong and we're looking into the problem. Please check back later.</p>
            <div className="d-flex flex-row justify-content-center gap-2 mt-4">
              <a href="/" className="btn btn-secondary" style={{fontSize: "1.171875rem;"}}>
                Home
              </a>
            </div>
          </p>
        </center>
      </div>
    </main>
  )
}
